<template>
  <div>
    隐私设置
  </div>
</template>

<script>
  export default {
    name: 'SettingsPrivacy'
  }
</script>

<style scoped>

</style>
